import { useTranslation } from 'react-i18next';
import { EvieOrb } from '@/components/primitives';
import { useEvieChatStore } from '@/store/evieChat';
import styles from './EvieLauncherButton.module.css';

/**
 * Global EVII launcher for the AppShell top bar — the driver mirror of the
 * admin's EvieLauncherButton (TopNav right rail). Toggles the single
 * AppShell-mounted sheet; the active conversation lives in the evieChat
 * store, so opening from here resumes wherever the driver left off.
 * Chrome matches the NotificationBell's 36px round icon button so the
 * top-bar cluster reads as one family.
 */
export function EvieLauncherButton() {
  const { t } = useTranslation('chrome');
  const open = useEvieChatStore((s) => s.open);
  const openSheet = useEvieChatStore((s) => s.openSheet);
  const closeSheet = useEvieChatStore((s) => s.closeSheet);
  return (
    <button
      type="button"
      className={styles.launcher}
      onClick={open ? closeSheet : openSheet}
      aria-label={t('evie.launcherAria')}
      aria-pressed={open}
      data-tour="evie-launcher"
    >
      <EvieOrb size={18} />
    </button>
  );
}
